import { fetch } from 'libs/fetch';
// 收货列表
export async function orderReceivingList(json): Promise<APIJSON<any>> {
  const res = await fetch('/api/tender/v1/mobile/purchaser/orderDelivery/receiving/searchList', {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}

// 申请退货预请求
export async function orderPreReturn(sysNo): Promise<APIJSON<any>> {
  return fetch(`/api/tender/v1/purchaser/orderReturn/preCreate/${sysNo}`, {
    needLogin: true,
    method: 'GET',
  });
}

// 申请退货-真实
export async function orderReturn(json): Promise<APIJSON<any>> {
  return fetch(`/api/tender/v1/purchaser/orderReturn/save`, {
    needLogin: true,
    method: 'POST',
    json,
  });
}

// 收货详情
export async function orderReturnDetailBySysNo(sysNo, user = 'purchaser'): Promise<APIJSON<any>> {
  return fetch(`/api/tender/v1/mobile/${user}/orderDelivery/receiving/detail/${sysNo}`, {
    needLogin: true,
    method: 'GET',
  });
}

// 收货作废
export async function receivingVoid(json): Promise<APIJSON<any>> {
  const res = await fetch('/api/tender/v1/mobile/purchaser/orderDelivery/receiving/void', {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}

export async function receivingSubmit(json): Promise<APIJSON<any>> {
  const res = await fetch('/api/tender/v1/mobile/purchaser/orderDelivery/receiving/submit', {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}

export async function receivingRemove(json): Promise<APIJSON<any>> {
  const res = await fetch('/api/tender/v1/mobile/purchaser/orderDelivery/receiving/remove', {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}
// 确认，拒绝 0-待确认 10-同意 20-不同意
export async function receivingConfirm(json): Promise<APIJSON<any>> {
  const res = await fetch('/api/tender/v1/mobile/supplier/orderDelivery/receiving/confirm', {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}

export async function receivingAuditCancel(json): Promise<APIJSON<any>> {
  const res = await fetch('/api/tender/v1/mobile/purchaser/orderDelivery/receiving/audit/cancel', {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}

// 退货列表
export async function orderReturnList(json): Promise<APIJSON<any>> {
  const res = await fetch('/api/tender/v1/purchaser/orderReturn/searchList', {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}

export function orderDeliveryList(json): FetchPromise<any> {
  return fetch(`/api/tender/v1/purchaser/orderDelivery/searchList`, {
    method: 'POST',
    json,
  });
}

export function orderMobileDeliveryList(json, user): FetchPromise<any> {
  return fetch(`/api/tender/v1/mobile/${user}/orderDelivery/searchList`, {
    method: 'POST',
    json,
  });
}

export function orderDeliveryRemove(json): FetchPromise<any> {
  return fetch(`/api/tender/v1/purchaser/orderDelivery/remove`, {
    method: 'POST',
    json,
  });
}

export function getOrderDeliveryDetail(sysNo, identity?: Identity): FetchPromise<any> {
  return fetch(`/api/tender/v1/mobile/${identity ?? 'purchaser'}/orderDelivery/get/${sysNo}`, {
    method: 'GET',
  });
}

// 删除
export function removeOrderDelivery(sysNo, identity?: Identity): FetchPromise<any> {
  return fetch(`/api/tender/v1/mobile/${identity ?? 'purchaser'}/orderDelivery/delete`, {
    method: 'POST',
    json: {
      sysNo,
    },
  });
}

// 作废
export function invalidOrderDelivery(sysNo): FetchPromise<any> {
  return fetch(`/api/tender/v1/mobile/supplier/orderDelivery/invalid`, {
    method: 'POST',
    json: {
      sysNo,
    },
  });
}

export function getOrderReturnDetail(sysNo): FetchPromise<any> {
  return fetch(`/api/tender/v1/purchaser/orderReturn/get/${sysNo}`, {
    method: 'GET',
  });
}

export function purchaserRevokeOrderReturn(sysNo): FetchPromise<any> {
  return fetch(`/api/tender/v1/purchaser/orderReturn/cancel`, {
    method: 'POST',
    json: {
      sysNo,
    },
  });
}

export function getEvaDetail(json, options?: FetchOptions) {
  return fetch<EvaluationDetail>('/api/supplier/v1/supplier/perfDynamicEvaluation/getDetail', {
    method: 'POST',
    ...options,
    json,
  });
}

export function getEvaDetailWithMarkCard(json, options?: FetchOptions) {
  return fetch<EvaluationDetail>(
    '/api/supplier/v1/supplier/perfDynamicEvaluation/getWithMarkCard',
    {
      method: 'POST',
      ...options,
      json,
    },
  );
}

export function getEvaQuickReason(json, options?: FetchOptions) {
  return fetch<EvaluationQuickReason[]>(
    '/api/supplier/v1/supplier/perfBusinessNodeQuickReason/getList',
    {
      method: 'POST',
      ...options,
      json,
    },
  );
}

export function searchEva(json): FetchPromise<PaginationResponse> {
  return fetch('/api/supplier/v1/supplier/perfDynamicEvaluation/search', {
    method: 'POST',
    json,
  });
}

export function updateEva(json) {
  return fetch<EvaluationQuickReason[]>('/api/supplier/v1/supplier/perfDynamicEvaluation/update', {
    method: 'POST',
    json,
  });
}

export function getEvaParam(options?: FetchOptions) {
  return fetch<DynamicEvaluation>('/api/tender/v1/purchaser/dynamicEvaluation/get', {
    method: 'POST',
    ...options,
  });
}

export function getEvaParamSupplier(options?: FetchOptions) {
  return fetch<DynamicEvaluation>('/api/tender/v1/supplier/dynamicEvaluation/get', {
    method: 'POST',
    ...options,
  });
}

export function getHomeInfo(): FetchPromise<any> {
  return fetch(`/api/tender/v1/purchaser/statistics/getHomeInfo`, {
    method: 'GET',
    needLogin: true,
  });
}

export function pruchaseGetStatistics(): FetchPromise<any> {
  return fetch(`/api/tender/v1/mobile/purchaser/home/statistics`, {
    method: 'GET',
    needLogin: true,
  });
}

export function supplierGetStatistics(): FetchPromise<any> {
  return fetch(`/api/tender/v1/mobile/supplier/home/statistics`, {
    method: 'GET',
    needLogin: true,
  });
}

export function supplierSearch(json): FetchPromise<any> {
  return fetch(`/api/tender/v1/supplier/search`, {
    method: 'POST',
    json,
  });
}

export function getTradeDetail(sysNo: string) {
  return fetch<TradeDetailEntity>(`/api/tender/v1/mobile/purchaser/orderTrade/get/${sysNo}`, {
    method: 'GET',
    needLogin: true,
  });
}

export function tenderProjectSearch(json): FetchPromise<any> {
  return fetch(`/api/tender/v1/tenderProject/search`, {
    method: 'POST',
    json,
  });
}

export function getLastProject(): FetchPromise<any> {
  return fetch(`/api/tender/v1/tenderProject/getLastProject`, {
    method: 'GET',
  });
}

export function saveLastProject(json): FetchPromise<any> {
  return fetch(`/api/tender/v1/tenderProject/saveLastProject`, {
    method: 'POST',
    json,
  });
}

export function searchOrganizationTree(json): FetchPromise<any> {
  return fetch(`/api/special/v1/basis/organization/searchOrganizationTree`, {
    method: 'POST',
    json,
  });
}

export function getOrganizationChilds(json): FetchPromise<any> {
  return fetch(`/api/special/v1/basis/organization/getOrganizationChilds`, {
    method: 'POST',
    json,
  });
}

export function endPurchaserReceiving(json): FetchPromise<any> {
  return fetch(`/api/tender/v1/mobile/purchaser/orderDelivery/endReceiving`, {
    method: 'POST',
    json,
  });
}

export function getTiledOrganizationByKeyword(json): FetchPromise<any> {
  return fetch(`/api/ifs/v1/basis/organization/getTiledOrganizationByKeyword`, {
    method: 'POST',
    json,
  });
}

export function saveTradeDetail(json: Partial<TradeDetailEntity>) {
  return fetch(`/api/tender/v1/purchaser/orderTrade/save`, {
    method: 'POST',
    json,
  });
}

export function submitTradeDetail(json) {
  return fetch(`/api/tender/v1/purchaser/orderTrade/submit`, {
    method: 'POST',
    json,
  });
}

export function sendNotify(json): FetchPromise<any> {
  return fetch(`/api/tender/v1/purchaser/orderTrade/sendNotify`, {
    method: 'POST',
    json,
  });
}

// 订单列表
export async function orderTradeList(json): Promise<APIJSON<any>> {
  const res = await fetch('/api/tender/v1/mobile/purchaser/orderTrade/search', {
    needLogin: true,
    wantError: true,
    method: 'POST',
    json,
  });
  return res;
}

// 收货单协议价
type GetPriceForReceiveJson = ['agreementEditionNo', 'deliverySysNo', 'mmu', 'receiveDate', 'sku'];
export function getPriceForReceive(
  json: {
    [k in GetPriceForReceiveJson[number]]: string;
  }[],
): FetchPromise<any> {
  return fetch('/api/tender/v1/mobile/orderTradePrice/getPriceForReceive', {
    method: 'POST',
    json,
  });
}

export function getOrderSteps(sysNo, by: ApplicationKey) {
  return fetch(`/api/tender/v1/mobile/${by}/orderTrade/getOrderSteps/${sysNo}`, {
    needLogin: true,
  });
}

export function getOrderReceivingSteps(sysNo) {
  return fetch(
    `/api/tender/v1/mobile/purchaser/orderDelivery/receiving/getReceivingSteps/${sysNo}`,
    {},
  );
}

export function getOrderDeliverSteps(sysNo, by: ApplicationKey) {
  return fetch(`/api/tender/v1/mobile/${by}/orderDelivery/getOrderDeliverySteps/${sysNo}`, {});
}

// 订单列表
export async function supplierOrderTradeList(json): Promise<APIJSON<any>> {
  const res = await fetch('/api/tender/v1/mobile/supplier/orderTrade/search', {
    needLogin: true,
    wantError: true,
    method: 'POST',
    json,
  });
  return res;
}

export async function supplierOrderReceivingList(json): Promise<APIJSON<any>> {
  const res = await fetch('/api/tender/v1/mobile/supplier/orderDelivery/receiving/searchList', {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}
// 完成发货
export async function orderDeliveryEndReceiving(json): Promise<APIJSON<any>> {
  const res = await fetch('/api/tender/v1/mobile/purchaser/orderDelivery/endReceiving', {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}

export async function getConfigOfEndReceiving(sysNo: number): Promise<APIJSON<any>> {
  const res = await fetch(
    `/api/tender/v1/mobile/purchaser/orderDelivery/getConfigOfEndReceiving/${sysNo}`,
    {
      needLogin: true,
      method: 'GET',
    },
  );
  return res;
}

export async function purchaseApplySearch(json) {
  const res = await fetch('/api/tender/v1/mobile/purchaser/purchaseApply/search', {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}

export async function purchaseApplyDetail(purchaseApplySysNo) {
  const res = await fetch(
    `/api/tender/v1/mobile/purchaser/purchaseApply/getDetail/${purchaseApplySysNo}`,
    {
      needLogin: true,
      method: 'GET',
    },
  );
  return res;
}

export async function purchaseApplyCancelAudit(sysNo) {
  const res = await fetch('/api/tender/v1/mobile/purchaser/purchaseApply/cancelAudit', {
    needLogin: true,
    method: 'POST',
    json: { sysNo },
  });
  return res;
}

export async function orderDeliveryAuditCancel(json) {
  const res = await fetch(
    '/api/tender/v1/mobile/purchaser/orderDelivery/audit/cancel',

    {
      needLogin: true,
      method: 'POST',
      json,
    },
  );
  return res;
}

export async function purchaseApplyDelete(sysNo) {
  const res = await fetch('/api/tender/v1/mobile/purchaser/purchaseApply/delete', {
    needLogin: true,
    method: 'POST',
    json: { sysNo },
  });
  return res;
}

export async function checkEndPurchaserReceiving(sysNo) {
  const res = await fetch('/api/tender/v1/purchaser/orderDelivery/checkToEndReceiving', {
    needLogin: true,
    method: 'POST',
    json: { sysNo },
  });
  return res;
}

export async function getReceivingAuditAndConfirmDimension() {
  const res = await fetch('/api/tender/v1/common/getReceivingAuditAndConfirmDimension', {
    needLogin: true,
    method: 'GET',
  });
  return res;
}

/**
 *
 * @param sysNo
 * @param confirmStatus  10 同意
 * @param confirmComment 20 拒绝
 * @returns
 */
export async function confirmReceiving(sysNo, confirmStatus: 10 | 20, confirmComment?: string) {
  const res = await fetch('/api/tender/v1/mobile/supplier/orderDelivery/confirmReceiving', {
    needLogin: true,
    method: 'POST',
    json: {
      sysNo,
      confirmStatus,
      confirmComment,
    },
  });
  return res;
}

export async function againBuyInfo(json) {
  const res = await fetch(`/api/tender/v1/purchaser/purchaseApply/againBuyInfo`, {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}

export async function purchaseApplyAddListAgain(json) {
  const res = await fetch(`/api/tender/v1/purchaser/purchaseApply/addListAgain`, {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}

export async function getTradeConfig() {
  const res = await fetch('/api/tender/v1/common/getTradeConfig', {
    needLogin: true,
    method: 'GET',
  });
  return res;
}

export async function evaGetWithMarkCardList(json) {
  const res = await fetch(`/api/supplier/v1/supplier/perfDynamicEvaluation/getWithMarkCardList`, {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}

export async function evaBatchUpdate(json) {
  const res = await fetch(`/api/supplier/v1/supplier/perfDynamicEvaluation/batchUpdate`, {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}
export async function evaBatchAdd(json) {
  const res = await fetch(`/api/supplier/v1/supplier/perfDynamicEvaluation/batchAdd`, {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}

export async function performanceFlowRuleUsingConfig(organizationSysNo) {
  const res = await fetch(
    `/api/tender/v1/mobile/performanceFlowRule/usingConfig/get/${organizationSysNo}`,
    {
      needLogin: true,
      method: 'GET',
    },
  );
  return res;
}

export async function purchaserOrderDeliveryConfirmReceiving(json) {
  const res = await fetch(`/api/tender/v1/purchaser/orderDelivery/confirmReceiving`, {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}

export async function searchMaterialLabels(): Promise<APIJSON<Array<MaterialLabel>>> {
  return fetch(`/api/material/v1/categoryWzgjTag/searchWzgjTagByName`, {
    method: 'GET',
  });
}

export async function getEffectPriceAuditList(json) {
  const res = await fetch(
    `/api/mall/v1/supplierSku/purchaser/getPurchaserSupplierSkuTradeAgreementEffectPriceAuditList`,
    {
      needLogin: true,
      method: 'POST',
      json,
    },
  );
  return res;
}

export async function purchaserSupplierSkuTradeAgreementEffectPriceAudit(json) {
  const res = await fetch(
    `/api/mall/v1/supplierSku/purchaser/supplierSkuTradeAgreementEffectPriceAudit`,
    {
      needLogin: true,
      method: 'POST',
      json,
    },
  );
  return res;
}

export async function purchaserSupplierConfirmDelivery(json) {
  const res = await fetch(`/api/tender/v1/purchaser/orderDelivery/confirmDelivery`, {
    needLogin: true,
    method: 'POST',
    json,
  });
  return res;
}

export async function checkConcreteAtribute(json) {
  const res = await fetch(`/api/tender/v1/concrete/attributeCheck`, {
    needLogin: true,
    method: 'POST',
    json,
    noErrorTip: true,
  });
  return res;
}

export async function getMixStation(json) {
  const res = await fetch(`/api/mall/v1/supplier/profile/getMixStation`, {
    needLogin: true,
    method: 'POST',
    json,
    noErrorTip: true,
  });
  return res;
}

export async function batchAddMixStation(json) {
  const res = await fetch(`/api/mall/v1/supplier/profile/batchAddMixStation`, {
    needLogin: true,
    method: 'POST',
    json,
    noErrorTip: true,
  });
  return res;
}

export async function contractSupplyChainSearch(json) {
  const res = await fetch(`/api/tender/v1/purchaser/contract/supplyChain/search`, {
    needLogin: true,
    method: 'POST',
    json,
    noErrorTip: true,
  });
  return res;
}

export async function returnProduct(sysNo): Promise<APIJSON<any>> {
  return fetch(`/api/tender/v1/purchaser/orderReturn/receiving/${sysNo}/detail/get`, {
    needLogin: true,
    method: 'GET',
  });
}

export async function subcontractorSearch(json?: any) {
  const res = await fetch('/api/supplier/v1/subcontractor/pageList', {
    method: 'POST',
    json,
  });
  return res;
}

export async function subcontractorCreate(json?: any) {
  const res = await fetch('/api/supplier/v1/subcontractor/create', {
    method: 'POST',
    json,
  });
  return res;
}
